import paths from './paths'

/** Route patterns keyed by commercial plan module (shared with Aside navigation). */
export const MODULE_ROUTE_CONFIG = {
  user_management: { prefix: '/users' },
  packages: { prefix: '/packages' },
  companies: ['/admin/companies', '/companies', '/admin/account-deletions', '/admin/super-admins', '/admin/sales-leads'],
  products: ['/products', '/labors', '/categories', '/brands', '/product-tags', '/product-badges', '/attribute-definitions', '/locations', '/uoms', '/pay-terms', '/work-order-types', '/taxes', '/barcode-generator'],
  warehouses: { prefix: '/warehouses' },
  vendors: { prefix: '/vendors' },
  stock_receipts: { prefix: '/stock-receipts' },
  stock_transfers: { prefix: '/stock-transfers' },
  purchase_orders: { prefix: '/purchase-orders' },
  vendor_bills: { prefix: '/vendor-bills' },
  inventory_adjustments: { prefix: '/adjustments' },
  customers: { prefix: '/customers' },
  sales: [
    '/invoices',
    '/device-types',
    '/devices',
    '/online-sales',
    '/sale-returns',
    '/storefront-inquiries',
    '/recurring-invoices',
    '/work-orders',
    '/work-orders-payments',
    '/receive-payments',
    '/estimates',
    '/payments',
    '/receipt-payments',
    '/receipts',
  ],
  expenses: [paths.expenses.list, paths.expenseCategories.list, paths.paymentAccounts.list, paths.paymentTypes.list],
  reports: [...Object.values(paths.accounting), '/inventory-report'],
  settings: [paths.settings.chartOfAccounts, paths.settings.payment, paths.settings.sms, paths.settings.pushNotifications, paths.settings.account, paths.settings.legalPolicies, paths.settings.storefrontProfile, paths.settings.storefrontReviews, paths.settings.productReviews, paths.settings.productImageOptimization, paths.settings.socialContent],
  marketing: [paths.marketing.socialContent, paths.marketing.creativeStudio],
  settings_subscription: [paths.settings.subscription],
  notifications: [paths.notifications],
  pos: { prefix: '/pos' },
}

/** @deprecated use MODULE_ROUTE_CONFIG — Aside legacy alias */
export const SIDEBAR_ROUTE_CONFIG = MODULE_ROUTE_CONFIG

export function matchesModuleRoute(route, pathname) {
  if (!route) return false
  return pathname === route || pathname.startsWith(`${route}/`)
}

export function matchesModuleRouteConfig(config, pathname) {
  if (Array.isArray(config)) return config.some((route) => matchesModuleRoute(route, pathname))
  if (config?.prefix) return matchesModuleRoute(config.prefix, pathname)
  return false
}
